import { render, staticRenderFns } from "./card-asset.vue?vue&type=template&id=94dcd6ee&scoped=true"
import script from "./card-asset.vue?vue&type=script&lang=js"
export * from "./card-asset.vue?vue&type=script&lang=js"
import style0 from "./card-asset.vue?vue&type=style&index=0&id=94dcd6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dcd6ee",
  null
  
)

export default component.exports